

    function initMap( el ) {
        
        // Find marker elements within map.
        var markers = el.querySelectorAll('.marker');
        
        // Create gerenic map.
        var mapArgs = {
            zoom: Number(el.dataset.zoom) || 16,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [
                {
                    "featureType": "all",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "color": "#878787"
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#f9f5ed"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#f5f5f5"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#c9c9c9"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#aee0f4"
                        }
                    ]
                }
            ]
        };

        var map = new google.maps.Map( el, mapArgs );
        

        // Add markers.
        map.markers = [];
        markers.forEach(function(marker){
            
            initMarker( marker, map );
        });

        // Center map based on markers.
        centerMap( map );

        // Return map instance.
        return map;
    }
    function initMarker(markerData, map) {
        // Get position from marker data
        const position = {
            lat: parseFloat(markerData.dataset.lat),
            lng: parseFloat(markerData.dataset.lng),
        };
        
        // Create the marker instance
        const marker = new google.maps.Marker({
            position,
            map,
        });

        map.markers.push(marker)
        
    
        // Check if the marker has associated HTML
        const content = markerData.innerHTML.trim();
        if (content) {
            const infoWindow = new google.maps.InfoWindow({
                content: content,
            });
    
            // Add a click listener to display the InfoWindow
            marker.addListener('click', function () {
                infoWindow.open(map, marker);
            });
        }
    }
    
    function centerMap( map ) {

        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function( marker ){
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng()
            });
        });

        // Case: Single marker.
        if( map.markers.length == 1 ){
            map.setCenter( bounds.getCenter() );

        // Case: Multiple markers.
        } else{
            map.fitBounds( bounds );
        }
    }
export default initMap;